import * as types from './mutation_types'

export default {
  [types.IS_LOADING_SCHEMA] (state, value) {
    state.isLoadingSchema = value
  },
  [types.ADD_TO_LIST_SCHEMA] (state, value) {
    const index = state.listSchema.findIndex(el => el.id === value.id)
    if (index > -1) {
      state.listSchema[index] = value
      state.listSchema = [...state.listSchema]
      return
    }
    state.listSchema = [...state.listSchema, value]
  },
  [types.POPULATE_LIST_SCHEMA] (state, value) {
    state.listSchema = value
  },
  [types.DELETE_FROM_LIST_SCHEMA] (state, schemaId) {
    const newVal = state.listSchema.filter(el => el.id !== schemaId)
    state.listSchema = [...newVal]
  },
  [types.SET_CURRENT_SELECTION] (state, value) {
    state.currentSelection = value
  },
  [types.SET_CURRENT_SCHEMA] (state, value) {
    state.currentSchema = value
  },
  [types.SET_ACTION] (state, value) {
    state.action = value
  },
  [types.SET_LAYER_TREE] (state, value) {
    state.layerTree = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/schemaFonctionnel/mutations.js